import { SupergatorActionTypes } from './supergator.types';

export const initialState = {
  sso: {
    loading: false,
    jwtData: null,
    error: null,
  },
};

const supergatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SupergatorActionTypes.SSO_EMIT_REQUEST:
      return {
        ...state,
        sso: {
          ...state.sso, loading: true, error: null, jwtData: null,
        },
      };

    case SupergatorActionTypes.SSO_EMIT_SUCCESS:
      return {
        ...state,
        sso: {
          ...state.sso, loading: false, jwtData: null, error: null,
        },
      };

    case SupergatorActionTypes.SSO_EMIT_FAILURE:
      return {
        ...state,
        sso: {
          ...state.sso, loading: false, jwtData: null, error: action.payload.error,
        },
      };

    default:
      return state;
  }
};

export default supergatorReducer;
